// extracted by mini-css-extract-plugin
export default {"countdown":"NfN2Qy6rECgLVcnlvPPyf"};